<template>
    <div
        v-if="users"
        class="container-fluid adminGroupUsersWrapper">
        <div class="d-block d-md-flex justify-content-end mb-3">
            <div class="mt-3">
                <button
                    type="button"
                    class="btn btn-yokumiru-orange mr-1"
                    style="min-width: 100px;"
                    @click="showModalAdminGroupUsersStore">
                    所属会員の追加
                </button>
                <b-button
                    variant="yokumiru-orange"
                    @click="downloadCSV"
                    :disabled="inProgress">
                    CSVダウンロード
                </b-button>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-md-12">
                <b-table
                    striped
                    hover
                    :items="users"
                    :fields="fields"
                    :sort-by.sync="morphState.sortBy"
                    :sort-desc.sync="morphState.sortDesc"
                    @sort-changed="fetchUsers"
                    :responsive="true"
                    class="table-bordered m-table">
                    <template v-slot:cell(full_name_kana)="data">
                        <a
                            href="#"
                            @click="showModalAdminUserProfile(data.item.id)">
                            {{ data.item.full_name }}
                        </a>
                        <div class="small">{{ data.item.full_name_kana }}</div>
                        <div
                            v-if="group.is_organization && data.item.is_company"
                            class="small mt-1">
                            <a :href="`/admin/companies/${userCompany(data.item).id}`">
                                <b-icon-building/>
                                <span>{{ userCompany(data.item).name }}</span>
                            </a>
                        </div>
                    </template>

                    <template v-slot:cell(user_category_id)="data">
                        <div v-for="userCategory in userCategories">
                            <div v-if="userCategory.id === data.item.user_category_id">
                                {{ userCategory.name }}
                            </div>
                        </div>
                    </template>

                    <template v-slot:cell(plan_id)="data">
                        <div v-if="data.item.plan">{{ data.item.plan.name.replace('サービスモデル', '') }}</div>
                        <div class="d-flex align-items-center small">
                            <a
                                href="#"
                                @click="showModalSubscriptionHistories(data.item, $event)">
                                サービスモデル履歴を表示
                            </a>
                        </div>
                    </template>

                    <template v-slot:cell(user_management_tags.name)="data">
                        <div class="userManagementTagsWrapper d-flex align-items-center">
                            <div
                                v-for="tag in data.item.user_management_tags"
                                class="d-flex align-baseline">
                                <div class="userManagementTag d-flex justify-content-center align-items-center">{{ tag.name }}</div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:cell(user_authorizer_tags.name)="data">
                        <div class="userAuthorizerTagsWrapper d-flex align-items-center">
                            <div
                                v-for="tag in filteredUserAuthorizerTags(data.item)"
                                class="align-baseline">
                                <div class="userAuthorizerTag d-flex justify-content-center align-items-center">{{ tag.name }}</div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:cell(birthday)="data">
                        <!-- ageは仮装フィールドなのでbirthdayでソートする（実質同じ結果になる） -->
                        <span>{{ data.item.age }}</span>
                    </template>

                    <template v-slot:cell(prefecture)="data">
                        <span>{{ data.item.prefecture }}</span>
                    </template>

                    <template v-slot:cell(registered_at)="data">
                        <div
                            v-if="data.item.registered_at"
                            class="u-palt">
                            <span class="small">
                                {{ helper.dateForHuman(data.item.registered_at, 'Asia/Tokyo') }}
                            </span>
                            <span
                                class="small font-weight-bold"
                                :class="helper.dayForHumanCSS(data.item.registered_at , 'Asia/Tokyo')">
                                {{ helper.dayForHuman(data.item.registered_at, 'Asia/Tokyo', {bracket: true}) }}
                            </span>
                        </div>
                    </template>

                    <template v-slot:cell(latest_consultation_start_time)="data">
                        <div v-if="data.item.latest_consultation">
                            <div class="u-palt">
                                <span class="small">
                                    {{ helper.dateForHuman(data.item.latest_consultation.start_time, 'Asia/Tokyo', { simpleYear: true }) }}
                                </span>
                                <span
                                    class="small font-weight-bold"
                                    :class="helper.dayForHumanCSS(data.item.latest_consultation.start_time , 'Asia/Tokyo')">
                                    {{ helper.dayForHuman(data.item.latest_consultation.start_time, 'Asia/Tokyo', { bracket: true }) }}
                                </span>
                            </div>
                            <div class="small">
                                {{ helper.timeForHuman(data.item.latest_consultation, 'Asia/Tokyo') }}
                            </div>
                        </div>
                    </template>

                    <template v-slot:cell(authorizer_id)="data">
                        <div class="text-center">
                            <input
                                v-model="authorizerId"
                                :value="data.item.id"
                                class="form-check-input radioAuthorizer"
                                type="radio"
                                @change="onChangeAuthorizer">
                        </div>
                    </template>

                    <template v-slot:cell(links)="data">
                        <b-button
                            type="button"
                            class="btn btn-danger btn-sm m-2"
                            @click="showModalAdminGroupUserLeave(data.item)">
                            所属を解除
                        </b-button>
                    </template>
                </b-table>

                <div class="d-flex flex-wrap justify-content-between align-items-center">
                    <b-pagination
                        :total-rows="morphState.total"
                        :per-page="morphState.per_page"
                        v-model="morphState.current_page"
                        @change="fetchUsers">
                    </b-pagination>

                    <div class="d-flex flex-wrap align-items-center">
                        <div class="mr-3 mb-3">
                            <span class="small">{{ dispPaginationDetail }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <admin-group-users-store-modal :joined-users="joinedUsers"/>
        <admin-group-user-leave-modal/>
        <admin-user-subscription-histories-modal/>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import constants from '../../../constants'
import YokumiruHelper from '../../../YokumiruHelper'
import { sprintf } from 'sprintf-js'
import moment from 'moment-timezone'

export default {
    name: 'AdminGroupUsers',

    props: {
        group: {
            type: Object,
            required: true,
        },
        userCategories: {
            type: Array,
            required: true,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            inProgress: false,
            users: null,
            joinedUsers: [],
            authorizerId: null,
            fields: [
                {
                    'key': 'id',
                    'label': '#',
                    sortable: true,
                },
                {
                    'key': 'full_name_kana',
                    'label': `${this.$locale.patient}名`,
                    sortable: true,
                },
                {
                    'key': 'user_category_id',
                    'label': `${this.$locale.patient}区分`,
                    sortable: true,
                },
                {
                    'key': 'plan_id',
                    'label': 'サービスモデル',
                    sortable: true,
                },
                {
                    'key': 'email',
                    'label': 'メールアドレス',
                    sortable: true,
                },
                {
                    'key': 'user_management_tags.name',
                    'label': '管理用タグ',
                    sortable: false,
                },
                {
                    'key': 'user_authorizer_tags.name',
                    'label': '担当者タグ',
                    sortable: false,
                },
                {
                    'key': 'user_code',
                    'label': '所属コード',
                    sortable: true,
                },
                {
                    'key': 'birthday',
                    'label': '年齢',
                    sortable: true,
                },
                {
                    'key': 'prefecture',
                    'label': '都道府県',
                    sortable: true,
                },
                {
                    'key': 'registered_at',
                    'label': '登録日',
                    sortable: true,
                },
                {
                    'key': 'latest_consultation_start_time',
                    'label': `最新の${this.$locale.consultation_host}予約日`,
                    sortable: true,
                },
                {
                    'key': 'consultation_count',
                    'label': `${this.$locale.consultation_host}回数`,
                    sortable: true,
                },
                {
                    'key': 'authorizer_id',
                    'label': '担当者設定',
                    sortable: false,
                },
                {
                    'key': 'links',
                    'label': '',
                    'class': 'text-center',
                    sortable: false,
                },
            ],
        }
    },

    computed: {
        isCompany: function () {
            return this.helper.isCompany(this.group)
        },

        isOrganization: function () {
            return this.helper.isOrganization(this.group)
        },

        morphState: function () {
            if (this.isCompany) {
                return this.$store.state.adminCompanyUsers
            }
            else if (this.isOrganization) {
                return this.$store.state.adminOrganizationUsers
            }
            return null
        },

        /**
         * ページング詳細表示
         * @returns {string}
         */
        dispPaginationDetail: function () {
            if (this.morphState.total < 1) {
                return ''
            }
            return `全${this.morphState.total}件中 ${this.morphState.from}～${this.morphState.to}件表示`
        },
    },

    created: function () {
        this.authorizerId = this.group.authorizer_id
        this.initQueryFromState()
        this.fetchUsers()
        this.fetchUserManagementTags()

        bus.$on('group-users-store', this.fetchUsers)
        bus.$on('group-user-leave', this.fetchUsers)

        bus.$on('group-groups-store', this.fetchUsers)
        bus.$on('group-group-leave', this.fetchUsers)
    },

    beforeDestroy: function () {
        bus.$off('group-users-store')
        bus.$off('group-user-leave')

        bus.$off('group-groups-store')
        bus.$off('group-group-leave')
    },

    methods: {
        ...mapMutations({
            setQueryCompany: 'adminCompanyUsers/setQuery',
            setQueriesCompany: 'adminCompanyUsers/setQueries',
            setQueryOrganization: 'adminOrganizationUsers/setQuery',
            setQueriesOrganization: 'adminOrganizationUsers/setQueries',
        }),

        setQuery: function (data) {
            if (this.isCompany) {
                this.setQueryCompany(data)
            }
            else if (this.isOrganization) {
                this.setQueryOrganization(data)
            }
        },

        setQueries: function (data) {
            if (this.isCompany) {
                this.setQueriesCompany(data)
            }
            else if (this.isOrganization) {
                this.setQueriesOrganization(data)
            }
        },

        /**
         * 検索条件の初期化
         */
        initQueryFromState: function () {
            if (localStorage.getItem('yokumiruWeb')) {
                const data = JSON.parse(localStorage.getItem('yokumiruWeb'))
                if (this.isCompany && data.adminCompanyUsers) {
                    this.setQueries(data.adminCompanyUsers)
                }
                else if (this.isOrganization && data.adminOrganizationUsers) {
                    this.setQueries(data.adminOrganizationUsers)
                }
            }
        },

        /**
         * 担当者変更
         */
        onChangeAuthorizer: function () {
            const endpoint = constants.admin.groups.endpoint.base

            axios.put(`${endpoint}/${this.group.id}/authorizer`, { authorizer_id: this.authorizerId })
                .then(() => {
                    bus.$emit('fetch-group')
                    bus.$emit('alert-success', '担当者を変更しました。')
                })
                .catch(({response}) => {
                    if (response &&
                        response.hasOwnProperty('data') &&
                        response.data.hasOwnProperty('errors') &&
                        response.data.errors.hasOwnProperty('message')) {
                        bus.$emit('alert-danger', response.data.errors.message[0])
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                })
        },

        /**
         * 会員管理用タグ一覧取得
         */
        fetchUserManagementTags: function () {
            axios.get(constants.admin.user_management_tags.endpoint.base)
                .then(({data}) => {
                    this.userManagementTags = data
                })
        },

        /**
         * 管理用タグ（担当者用）
         * @param {object} user
         * @return {array}
         */
        filteredUserAuthorizerTags: function (user) {
            if (user.user_authorizer_tags.length < 1) {
                return []
            }
            return user.user_authorizer_tags.filter((tag) => tag.authorizer_id === this.group.authorizer_id)
        },

        /**
         * サービスモデル履歴モーダル表示
         * @param {object} user
         * @param {object} e
         */
        showModalSubscriptionHistories: function (user, e) {
            e.preventDefault()
            bus.$emit('open-modal-subscription-histories', user)
        },

        /**
         * 会員一覧取得
         *
         * @param {number|object} param
         */
        fetchUsers: async function (param = null) {
            this.users = null

            if (Number.isInteger(param) && param > 0) {
                await this.setQuery({ key: 'current_page', value: param })
            }
            else if (param !== null && param.hasOwnProperty('sortBy')) {
                await this.setQuery({ key: 'sortBy', value: param.sortBy })
                await this.setQuery({ key: 'sortDesc', value: param.sortDesc })
            }

            const endpoint = constants.admin.groups.endpoint.base

            // ページング表示用
            axios.get(`${endpoint}/${this.group.id}/users${this.buildQuery()}`)
                .then(({data}) => {
                    this.users = data.data
                    this.setQueries(data.meta)
                })

            // 所属会員すべて（所属会員の追加が可能かどうかの判定用）
            axios.get(`${endpoint}/${this.group.id}/users`)
                .then(({data}) => {
                    this.joinedUsers = data.data
                })
        },

        /**
         * QueryString生成
         *
         * @param {boolean} paginate
         * @return {string}
         */
        buildQuery: function (paginate = true) {
            let query = '?'

            if (paginate) {
                query += `page=${this.morphState.current_page}`
                query += `&sort=${this.morphState.sortBy}`
                query += `&desc=${this.morphState.sortDesc}`
            }
            else {
                query += `sort=${this.morphState.sortBy}`
                query += `&desc=${this.morphState.sortDesc}`
            }

            return query
        },

        /**
         * 追加モーダル表示
         */
        showModalAdminGroupUsersStore: function () {
            bus.$emit('open-modal-admin-group-users-store', this.group)
        },

        /**
         * 追加モーダル表示
         *
         * @param {object} user
         */
        showModalAdminGroupUserLeave: function (user) {
            bus.$emit('open-modal-admin-group-user-leave', this.group, user)
        },

        /**
         * 会員詳細モーダル表示
         *
         * @param {number} userId
         */
        showModalAdminUserProfile: function (userId) {
            bus.$emit('open-modal-admin-user-profile', userId)
        },

        /**
         * 会員の法人を取得
         * @param {object} user
         * @return {object}
         */
        userCompany: function (user) {
            return this.helper.userCompany(user) || {}
        },

        /**
         * CSVダウンロード
         */
        downloadCSV: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = `${constants.admin.groups.endpoint.base}/${this.group.id}/users/export${this.buildQuery(false)}`
            const options = { responseType : 'blob' }

            await axios.get(endpoint, options)
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: response.data.type,
                    })
                    saveAs(
                        blob,
                        sprintf(
                            '%s_%s一覧_%s.csv',
                            this.group.name,
                            this.$locale.patient,
                            moment().format('YYYYMMDD')
                        )
                    )
                })
                .catch(() => {
                    bus.$emit('alert-danger', 'システムエラーが発生しました。')
                })

            this.inProgress = false
        },
    },
}
</script>

<style lang="scss" scoped>
.userManagementTagsWrapper {
    overflow-x: scroll;
    white-space: pre;
    width: 120px;
    padding: 5px 0;
    box-sizing: border-box;

    .userManagementTag {
        padding: 3px 5px;
        margin-right: 5px;
        color: #3461b4;
        font-size: .85em;
        background-color: #f2f4f8;
        border: 1px solid #dce4ed;
        border-radius: 2px;
    }
}

.userAuthorizerTagsWrapper {
    overflow-x: scroll;
    white-space: pre;
    width: 120px;
    padding: 5px 0;
    box-sizing: border-box;

    .userAuthorizerTag {
        padding: 3px 5px;
        margin-right: 5px;
        color: #5834b4;
        font-size: .85em;
        background-color: #f4f2f8;
        border: 1px solid #e2dced;
        border-radius: 2px;
    }
}

.radioAuthorizer {
    position: relative;
    cursor: pointer;
}
</style>

<style lang="scss">
.adminGroupUsersWrapper {
    .b-table {
        min-width: 1600px;

        th, td {
            font-size: 0.75rem;
        }
    }
}
</style>
